import { searchFilters, allCategories, allLanguages, allCountries } from '@/mocks/searchRadios';

interface FilterSidebarProps {
  activeFilters: string[];
  selectedCategory: string;
  selectedLanguage: string;
  selectedCountry: string;
  onToggleFilter: (key: string) => void;
  onCategoryChange: (cat: string) => void;
  onLanguageChange: (lang: string) => void;
  onCountryChange: (country: string) => void;
  onClearAll: () => void;
}

export default function FilterSidebar({
  activeFilters,
  selectedCategory,
  selectedLanguage,
  selectedCountry,
  onToggleFilter,
  onCategoryChange,
  onLanguageChange,
  onCountryChange,
  onClearAll,
}: FilterSidebarProps) {
  const hasAnyFilter = activeFilters.length > 0 || selectedCategory !== 'Todas' || selectedLanguage !== 'Todos' || selectedCountry !== 'Todos';

  return (
    <aside className="w-full lg:w-64 shrink-0">
      <div className="lg:sticky lg:top-24 space-y-5">
        <div className="flex items-center justify-between">
          <h3 className="text-sm font-semibold text-foreground-950 flex items-center gap-2">
            <i className="ri-equalizer-line text-base text-primary-500"></i>
            Filtros
          </h3>
          {hasAnyFilter && (
            <button
              onClick={onClearAll}
              className="text-xs text-primary-600 hover:text-primary-700 font-medium transition-colors cursor-pointer whitespace-nowrap"
            >
              Limpiar todo
            </button>
          )}
        </div>

        <div className="space-y-1.5">
          <p className="text-xs font-medium text-foreground-500 uppercase tracking-wider">Rápidos</p>
          <div className="flex flex-wrap gap-1.5">
            {searchFilters.map((f) => (
              <button
                key={f.key}
                onClick={() => onToggleFilter(f.key)}
                className={`flex items-center gap-1.5 px-3 py-1.5 text-xs font-medium rounded-full transition-all duration-200 cursor-pointer whitespace-nowrap ${
                  activeFilters.includes(f.key)
                    ? 'bg-primary-500 text-background-50'
                    : 'bg-background-100 text-foreground-600 hover:bg-background-200/70 hover:text-foreground-800'
                }`}
              >
                <i className={`${f.icon} text-sm`}></i>
                {f.label}
              </button>
            ))}
          </div>
        </div>

        <div className="space-y-1.5">
          <p className="text-xs font-medium text-foreground-500 uppercase tracking-wider">Categoría</p>
          <div className="space-y-0.5 max-h-48 overflow-y-auto">
            {allCategories.map((cat) => (
              <button
                key={cat}
                onClick={() => onCategoryChange(cat)}
                className={`w-full text-left px-3 py-2 text-sm rounded-lg transition-all duration-150 cursor-pointer whitespace-nowrap ${
                  selectedCategory === cat
                    ? 'bg-primary-50 text-primary-700 font-medium'
                    : 'text-foreground-600 hover:bg-background-100 hover:text-foreground-800'
                }`}
              >
                {cat}
              </button>
            ))}
          </div>
        </div>

        <div className="space-y-1.5">
          <p className="text-xs font-medium text-foreground-500 uppercase tracking-wider">Idioma</p>
          <div className="space-y-0.5">
            {allLanguages.map((lang) => (
              <button
                key={lang}
                onClick={() => onLanguageChange(lang)}
                className={`w-full text-left px-3 py-2 text-sm rounded-lg transition-all duration-150 cursor-pointer whitespace-nowrap ${
                  selectedLanguage === lang
                    ? 'bg-primary-50 text-primary-700 font-medium'
                    : 'text-foreground-600 hover:bg-background-100 hover:text-foreground-800'
                }`}
              >
                {lang}
              </button>
            ))}
          </div>
        </div>

        <div className="space-y-1.5">
          <p className="text-xs font-medium text-foreground-500 uppercase tracking-wider">País</p>
          <div className="space-y-0.5 max-h-48 overflow-y-auto">
            {allCountries.map((country) => (
              <button
                key={country}
                onClick={() => onCountryChange(country)}
                className={`w-full text-left px-3 py-2 text-sm rounded-lg transition-all duration-150 cursor-pointer whitespace-nowrap ${
                  selectedCountry === country
                    ? 'bg-primary-50 text-primary-700 font-medium'
                    : 'text-foreground-600 hover:bg-background-100 hover:text-foreground-800'
                }`}
              >
                {country}
              </button>
            ))}
          </div>
        </div>
      </div>
    </aside>
  );
}